export default __webpack_public_path__ + "static/media/movipack_feature4.fad62a8a.svg";